import React from 'react';
import { motion } from 'framer-motion';
import { Check, Lock, Zap } from 'lucide-react';
import { books } from '../data/books';
import { CHECKOUT_URL } from '../data/checkout';
import { optimizedImage } from '../utils/images';
import { CtaButton } from './CtaButton';
export function FinalCtaSection() {
  return <section id="checkout" className="relative overflow-hidden border-b border-gold-500/15 bg-noir-900 py-14 sm:py-24 lg:py-28" data-id="element-78" data-mp="3vrkxbhuawbdd">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-0 h-[520px] w-[900px] -translate-x-1/2 rounded-full bg-crimson-600/12 blur-[130px]" data-id="element-79" data-mp="2y2rddm4v6z88" />
      <div className="container relative" data-id="element-80" data-mp="380yovpgdwp2u">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} className="mx-auto max-w-3xl text-center" data-id="element-81" data-mp="3cua002s8bs0k">
          <p className="text-sm font-medium uppercase tracking-widest2 text-gold-400" data-id="element-82" data-mp="2dbqld2v30zu6">
            La única pregunta que importa ahora es:
          </p>
          <h2 className="mt-5 font-display text-[1.8rem] font-bold leading-[1.12] text-cream sm:mt-6 sm:text-5xl" data-id="element-83" data-mp="28dp3umdb18kt">
            ¿Cuántas oportunidades más vas a dejar pasar?
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-cream/65 sm:mt-6 sm:text-base" data-id="element-84" data-mp="1ymc83jodxy9i">
            Cada día sin esta información es otro día perdiendo conexiones, arruinando
            momentos y dejando ir personas que podrían haber cambiado tu vida.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 34
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.7,
        delay: 0.1,
        ease: [0.22, 1, 0.36, 1]
      }} className="mx-auto mt-9 max-w-2xl rounded-3xl border border-gold-500/30 bg-noir-800/85 p-6 text-center sm:mt-14 sm:p-12" data-id="element-85" data-mp="1knl1eibureve">
          <div className="perspective-[1400px] mx-auto mb-7 flex max-w-[280px] items-end justify-center sm:mb-9 sm:max-w-sm" data-id="element-86" data-mp="18cbluewonr1b">
            {books.map((book, index) => <motion.img key={book.id} src={optimizedImage(book.cover, 240)} onError={event => {
            event.currentTarget.src = book.cover;
          }} alt="" aria-hidden="true" width={1024} height={1536} loading="lazy" decoding="async" initial={{
            opacity: 0,
            y: 22,
            rotate: 0
          }} whileInView={{
            opacity: 1,
            y: 0,
            rotate: (index - 2) * 4
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2 + index * 0.07
          }} className="-ml-5 w-[19%] rounded-[3px] ring-1 ring-gold-500/25 shadow-[0_14px_28px_-12px_rgba(0,0,0,0.9)] first:ml-0" data-id="element-87" data-mp="yffj6ptgtz4o" data-mpi={index} />)}
          </div>

          <p className="text-[11px] font-medium uppercase tracking-widest2 text-cream/45 sm:text-xs" data-id="element-88" data-mp="34iuzd0z2ftp">
            Valor real: <span className="line-through" data-id="element-89" data-mp="3ubvbdpu16p8k">$137.00 USD</span>
          </p>
          <p className="mt-2.5 font-display text-[3.25rem] font-bold leading-none text-cream sm:mt-3 sm:text-7xl" data-id="element-90" data-mp="d2os7hbu2xs8">
            $9.99
          </p>
          <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-crimson-600/15 px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-wider text-crimson-500 ring-1 ring-crimson-500/35 sm:mt-5 sm:px-4 sm:py-2 sm:text-xs" data-id="element-91" data-mp="832buz0pl1f7">
            <Zap className="h-3.5 w-3.5" aria-hidden="true" data-id="element-92" data-mp="3qarud008yn5r" />
            93% de descuento — Precio de lanzamiento
          </p>

          <div className="mt-7 sm:mt-9" data-id="element-93" data-mp="3li8iq8l4e23l">
            <CtaButton href={CHECKOUT_URL} fireAddToCart className="w-full" data-id="element-94" data-mp="2xu8rl7jwc9oh">
              <Check className="h-5 w-5" aria-hidden="true" data-id="element-95" data-mp="2xs4cdtgjro8w" />
              Quiero los 5 Ebooks Ahora — Solo $9.99
            </CtaButton>
          </div>

          <p className="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-[11px] text-cream/45 sm:mt-7 sm:text-xs" data-id="element-96" data-mp="1w4scelr7a7ik">
            <span className="flex items-center gap-1.5" data-id="element-97" data-mp="205m3tp3uq4g7">
              <Lock className="h-3.5 w-3.5 text-gold-500" aria-hidden="true" data-id="element-98" data-mp="25474tqqxgs5p" />
              Pago 100% seguro
            </span>
            <span aria-hidden="true" data-id="element-99" data-mp="29wqdqaeo6z46">·</span>
            <span data-id="element-100" data-mp="2euigy0krm7no">Acceso inmediato</span>
            <span aria-hidden="true" data-id="element-101" data-mp="2etguz127o0r6">·</span>
            <span data-id="element-102" data-mp="2jtbkb06c8ia4">Tuyo para siempre</span>
          </p>
        </motion.div>
      </div>
    </section>;
}